import { useState, useEffect } from 'react'

import Brand from 'helpers/brand'

import Api from 'services/api'

import Resource from 'types/Resource'

type Props = {
  brand?: string
  publishedOnly: boolean
  refreshTimestamp?: number
}

const useResources = ({ brand = Brand.current(), publishedOnly, refreshTimestamp = 0 }: Props) => {
  const [articles, setArticles] = useState<Array<Resource>>([])
  const [faqs, setFaqs] = useState<Array<Resource>>([])
  const [videos, setVideos] = useState<Array<Resource>>([])
  const [thermostatReleases, setThermostatReleases] = useState<Array<Resource>>([])
  const [areResourcesLoaded, setAreResourcesLoaded] = useState(false)

  useEffect(() => {
    setAreResourcesLoaded(false)
    Api.Resources.list(brand, publishedOnly)
      .then((response) => {
        setArticles(response.articles)
        setFaqs(response.faqs)
        setVideos(response.videos)
        setThermostatReleases(response.thermostatReleases)
      })
      .catch(() => {
        setArticles([])
        setFaqs([])
        setVideos([])
      })
      .finally(() => {
        setAreResourcesLoaded(true)
      })
  }, [brand, publishedOnly, refreshTimestamp])

  return { articles, faqs, videos, thermostatReleases, areResourcesLoaded }
}

export default useResources
